import React, { useState } from "react";
import axios from "axios";
import AttendanceLayout from "../components/AttendanceLayout";

const AttendanceScreen = () => {
  const [employeeId, setEmployeeId] = useState("");
  const [pin, setPin] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:5001";

  const submitAttendance = async (type) => {
    const cleanEmployeeId = employeeId.trim();
    const cleanPin = pin.trim();

    if (!cleanEmployeeId || !cleanPin) {
      setMessage("Employee ID and PIN are required");
      return;
    }

    const endpoint = type === "in" ? "/attendance/timein" : "/attendance/timeout";

    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(`${apiUrl}${endpoint}`, {
        employeeId: cleanEmployeeId,
        pin: cleanPin,
      });

      setMessage(response.data?.message || (type === "in" ? "Time in successful" : "Time out successful"));
      setEmployeeId("");
      setPin("");
    } catch (err) {
      setMessage(err.response?.data?.message || err.response?.data?.error || "Unable to process attendance");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AttendanceLayout>
      <h1 className="text-2xl font-semibold text-gray-900 mb-5 text-center">Attendance</h1>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Employee ID</label>
          <input
            type="text"
            value={employeeId}
            onChange={(e) => setEmployeeId(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
            placeholder="Enter Employee ID"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">PIN</label>
          <input
            type="password"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500"
            placeholder="Enter PIN"
          />
        </div>

        <div className="flex gap-2 pt-2">
          <button
            type="button"
            disabled={loading}
            onClick={() => submitAttendance("in")}
            className="flex-1 bg-teal-500 hover:bg-teal-600 text-white font-medium py-2 rounded disabled:opacity-60"
          >
            Time In
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={() => submitAttendance("out")}
            className="flex-1 bg-gray-700 hover:bg-gray-800 text-white font-medium py-2 rounded disabled:opacity-60"
          >
            Time Out
          </button>
        </div>

        {message && (
          <p className="text-sm text-center text-gray-700 pt-2">{message}</p>
        )}
      </div>
    </AttendanceLayout>
  );
};

export default AttendanceScreen;
